import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title[]{${richTextFields}},
  items[]{
    title,
    content[]{${richTextFields}}
  }
`

export const fragment = (name = 'rotatingPoints') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
